import * as React from 'react';
import Link from '@mui/joy/Link';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import CardCover from '@mui/joy/CardCover';

const DestinationItem = ({ destination }) => {
    const {
        id,
        name,
        place_address,
        cover_photos,
    } = destination;
    let image = "https://images.unsplash.com/photo-1542773998-9325f0a098d7?auto=format&fit=crop&w=320";
    if (cover_photos && cover_photos.length > 0) {
        image = cover_photos[0].image_link;
    }
    return (
        <Card
            sx={{
                minHeight: '200px',
                width: { xs: '100%', sm: 250 },
                cursor: 'pointer',
                transition: 'transform 200ms ease, box-shadow 200ms ease',
                '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: 'md',
                },
            }}
        >
            <CardCover>
                <img
                    src={image}
                    loading="lazy"
                    alt={name}
                />
            </CardCover>
            <CardCover
                sx={{
                    background:
                        'linear-gradient(to top, rgba(0,0,0,0.5), rgba(0,0,0,0) 200px), linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0) 120px)',
                }}
            />
            <CardContent sx={{ justifyContent: 'flex-end' }}>
                <Typography level="title-lg" textColor="#fff">
                    <Link
                        overlay
                        underline="none"
                        href={`/destination/${id}`}
                        sx={{ color: "#fff" }}
                    >
                        {name}
                    </Link>
                </Typography>
                <Typography
                    startDecorator={<LocationOnRoundedIcon />}
                    textColor="neutral.300"
                >
                    {place_address}
                </Typography>
            </CardContent>
        </Card>
    );
}

export default DestinationItem;